import { defineStore } from 'pinia';
import type { Error } from '@/types/models/error.d';
import { assign } from '@/utils/common/common';
import { useLoadingStore } from './loading';
import { type Ref, ref } from 'vue';

const INITIAL_ERROR = <Error>{
  showDialog: false,
  title: '',
  message: '',
  status: '',
  redirect: false,
  closeNavigateTo: undefined,
};

export const useErrorStore = defineStore('error', () => {
  const error: Ref<Error> = ref({ ...INITIAL_ERROR });

  const set = (e: Error) => {
    useLoadingStore().set(false);
    error.value = e;
  };

  const update = (e: Error) => {
    assign(error.value, e);
  };

  const reset = () => {
    error.value = { ...INITIAL_ERROR };
  };

  return {
    error,
    set,
    update,
    reset,
  };
});
